import request from '../utils/request';

export function getPlatformList(params) {
    return request({
        url: '/config/platform/list',
        method: 'get',
        params
    });
}

export function savePlatform(data) {
    return request({
        url: '/config/platform/save',
        method: 'post',
        data
    });
}

export function getMacRule(params) {
    return request({
        url: '/config/mac-rule',
        method: 'get',
        params
    });
}

export function saveMacRule(data) {
    return request({
        url: '/config/mac-rule/save',
        method: 'post',
        data
    });
}

export function getModelList(params) {
    return request({
        url: '/config/model/list',
        method: 'get',
        params
    });
}

export function saveModel(data) {
    return request({
        url: '/config/model/save',
        method: 'post',
        data
    });
}

export function updateModelStatus(data) {
    return request({
        url: '/config/model/status',
        method: 'post',
        data
    });
}

export function getFactoryList(params) {
    return request({
        url: '/config/factory/list',
        method: 'get',
        params
    });
}

export function saveFactory(data) {
    return request({
        url: '/config/factory/save',
        method: 'post',
        data
    });
}

export function getNotifyConfig(params) {
    return request({
        url: '/config/notify',
        method: 'get',
        params
    });
}

export function saveNotifyConfig(data) {
    return request({
        url: '/config/notify/save',
        method: 'post',
        data
    });
}

export function testNotify(data) {
    return request({
        url: '/config/notify/test',
        method: 'post',
        data
    });
}
